import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  Card,
  Grid,
  MenuItem,
  Select,
  CardContent,
  Typography,
  CardHeader,
  Box,
  Menu,
  Divider,
  IconButton,
} from "@material-ui/core";
import {
  AddBox,
  MoreVert,
  AddCircle,
  Warning,
  WarningOutlined,
  WarningRounded,
} from "@material-ui/icons";
import Chart from "react-google-charts";
import { Autocomplete } from "@material-ui/lab";
import Avatar from "@material-ui/core/Avatar";
import red from "@material-ui/core/colors/red";
import { array } from "prop-types";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },

  // avatar: {
  //   fontSize: 12,
  // },
  avatar1: {
    fontSize: 12,
  },
  redAvatar: {
    fontSize: 12,
    color: "#fff",
    margin: 5,
    backgroundColor: red[500],
  },
  card: {
    maxWidth: 250,
    margin: "auto",
    transition: "0.3s",
    boxShadow: "0 8px 40px -12px rgba(0,0,0,0)",
    "&:hover": {
      boxShadow: "0 16px 70px -12.125px rgba(0,0,255,0.3)",
    },
  },
}));

export default function GraficaTareas(props) {
  const {
    register,
    errors,
    defaultItem,
    ctl,
    ctll,
    cerrar,
    clickEditar,
  } = props;
  const [data, setData] = useState([]);
  const [modal, setModal] = useState({ open: false, titulo: "" });
  const classes = useStyles();
  const descargarDocs = (e) => {
    clickEditar(e);
  };


  return (
    <Card>
      {/* <CardHeader style={{ textAlign: "center" }} title="Tareas" /> */}
      <Divider />
      <CardContent>
        <Grid container spacing={3}></Grid>
        <br />
        <Divider />
        <Box
          // height={400}
          position="relative"
        >
          {ctl.length > 0 && (
            <Chart
              chartLanguage={"es"}
              chartType="Timeline"
              loader={<div>Loading Chart</div>}
              rows={ctl.map((vst) => [
                vst.titulo,
                vst.proceso == "Real" ? '' : 'Real',
                vst.proceso == "Real" ? "#087AC1": "#C6C5C5",
                // 'Real',
                new Date(vst.fecha_real_inicio),
                // new Date(vst.fecha_real_termino),
                new Date(new Date(vst.fecha_real_termino).setHours(vst.nhoras_tarea))
              ] 
              )}
              columns={[
                  { type: "string", id: "titulo" },
                  { type: "string", id: "proceso" },
                  { type: "string",  role: 'style' },
                  { type: "date", id: "fecha_real_inicio" },
                  { type: "date", id: "fecha_real_termino" }
              ]}
              // data={
              //   ([
              //     { type: "string", id: "titulo" },
              //     { type: "string", id: "proceso" },
              //     // { type: "string",  role: 'style' },
              //     { type: "date", id: "fecha_real_inicio" },
              //     { type: "date", id: "fecha_real_termino" }
              //   ],
              //   ctl.map((vst) => [
              //     vst.titulo,
              //     vst.proceso == "Real" ? '' : 'Real',
              //     // "#087AC1",
              //     // 'Real',
              //     new Date(vst.fecha_real_inicio),
              //     new Date(vst.fecha_real_termino),
              //   ] 
              //   ))
                // console.log(ctl.map((vst) => [
                //   vst.titulo,
                //   vst.proceso == "Real" ? '' : 'Real',
                //   // 'Real',
                //   new Date(vst.fecha_real_inicio),
                //   new Date(vst.fecha_real_termino),
                // ])))
              // }
              options={{
                width: "100%",
                height: "450px",
               
                colors: ["#087AC1", "#C6C5C5","#087AC1"],
                // timeline: { showRowLabels: false },
                // avoidOverlappingGridLines: false,
                 colorMap : {
                  // should contain a map of category -> color for every category
                  CategoryA: '#087AC1',
                  CategoryB: '#C6C5C5'
              },
                tooltip: { trigger: 'none' } ,
                vAxes: {
                  0: { baseline: 0 },
                },

                timeline: {
                  colorByRowLabel: false,
                  rowLabelStyle: { fontSize: 10, color: '#603913' },
                  enableInteractivity: false,
                  groupByRowLabel: true,
                },
                alternatingRowStyle: false
              }}
              chartEvents={[
                {
                  eventName: "ready",
                  callback: ({ chartWrapper, google }) => {
                    const chart = chartWrapper.getChart();
                    function selectHandler(myChart) {
                      var selectedItem = myChart.getSelection()[0];

                      descargarDocs(myChart.getSelection()[0].row);
                    }
                    google.visualization.events.addListener(
                      chart,
                      "select",
                      function() {
                        selectHandler(chart);
                      }
                    );
                  },
                },
              ]}
            />
          )}
        </Box>
      </CardContent>
    </Card>
  );
}
